import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import Imagic from "../../../../components/imagic/imagic";
import { Product, ProductList } from "../../../../models/product-list";
import { API } from "../../../../services/api-services";
import { ROUTES } from "../../../../services/router-services";
import { _c } from "../../../../services/text-services";
import Breadcrumbs from "../../../shared/breadcrumbs/breadcrumbs";
import FetchData from "../../../shared/fetch-data/fetch-data";
import MoreInfo from "../../../shared/more-info/more-info.component";
import List2 from "../List2/list2";
import styles from "./product-list.module.scss";

interface ProductListProps {
  productList: ProductList;
}

function ProductList({ productList }: ProductListProps) {
  const product_list_limit = Number(process.env.NEXT_PUBLIC_PRODUCT_LIST_LIMIT) || 24;
  const [showLoadMore, setShowLoadMore] = useState<boolean>(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [limit, setLimit] = useState<number>(product_list_limit);
  const [isFetched, setIsFetched] = useState<boolean>(true);
  const [url, setUrl] = useState<string>("");
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [posterImageSrc, setPosterImageSrc] = useState("");
  const preloaderEl = useRef<HTMLDivElement | null>(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const initialPosterSrc = productList.category?.feature_avatar?.xxhdpi || productList.category?.feature_avatar?.xhdpi;
  const router = useRouter();

  useEffect(() => {
    setFirstLoad(false)
  }, []);

  useEffect(() => {
    if (!firstLoad) router.reload();
  }, [router.asPath]);
  useEffect(() => {
    if (!productList) return;
    setProducts(productList.products);
    setShowLoadMore(productList?.products.length === product_list_limit + 1 ? true : false);
    const timeout = setTimeout(() => setShowMoreInfo(true), 500);

    return () => clearTimeout(timeout);
    
  }, [productList])

  useEffect(() => {
    if (!preloaderEl.current) return;
    const tmpsrc = preloaderEl.current?.children?.[0]?.children?.[1]?.getAttribute("src");
    if (tmpsrc?.includes("/_next/image?url=")) setPosterImageSrc(tmpsrc);
  }, [preloaderEl.current?.children?.[0]?.children?.[1]?.getAttribute("src")]);

  const loadMoreProduct = () => {
    if (isFetched) {
      setIsFetched(true);
      setUrl(
        API.request_product_list(
          +productList.category.id,
          limit + product_list_limit + 1
        )
      );
      setLimit(prev => prev + product_list_limit);
    }
  };

  return (
    <>
      {!!url && (
        <FetchData
          url={url}
          method="GET"
          with_dg_id
          unAuthorized
          onSuccessful={data => {
            const res = data as ProductList;
            setProducts(res.products);
            setIsFetched(true);
            setShowLoadMore(res.products.length === limit + 1 ? true : false);
          }}
        />
      )}
      <div className={_c(styles, "wrapper-describe  pb-5")}>
        {/*<!-- category details --> */}
        <div className={_c(styles, "details-container")}>
          {(initialPosterSrc && !posterImageSrc) && <div 
            className={_c(styles, "image-loader")}
            ref={preloaderEl}
          >
            <Image
              width={768}
              height={375}
              src={initialPosterSrc}
              alt="poster-image"
              priority
            />
          </div>}
          {posterImageSrc && <div
            className={_c(styles, "details")}
            style={{
              backgroundImage: `url(${posterImageSrc})`
            }}
          >
            { productList?.category?.id && <div className={`${styles.breadcrumb_wrapper} desktop`}>
            {productList?.category &&<Breadcrumbs
              crumbs={[
                {
                  href: ROUTES.root,
                  text: "خانه"
                },
                {
                  href: ROUTES.categories,
                  text: "دسته بندی"
                },
                {
                  href: ROUTES.category(productList.category.title_en || "", productList.category.id || 0),
                  text: productList?.category?.title || "دسته بندی"
                }
              ]}
              customstyle={{color: "#ffffff"}}
            />}
            </div>}
            <h1 className={styles.title}> {productList.category.title}</h1>
            <div className={_c(styles, "layer")}></div>
          </div>}
        </div>

        {/*<!-- products list -->*/}
        <div className={_c(styles, "product-list")}>
          <div className="container">
            <div className={_c(styles, "mb-2")}>
            </div>
            <List2
              products={products}
              showLoadMore={showLoadMore}
              limit={limit}
              loadMoreProduct={() => {
                loadMoreProduct();
              }}
            />
            {/*<!-- more info -->*/}
            {productList.category.description && products && showMoreInfo && (
              <div className={_c(styles, "description")}>
                <section>
                  <div className="container pl-5 pr-5">
                    <MoreInfo
                      title={`${productList?.category?.title} | ${productList?.category?.title_en}`}
                      description={productList?.category?.description}
                    />
                  </div>
                </section>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductList;
